import { useUserOrganization, useUserOrganizationSettings } from '@modules-deprecated/app/organization'

import { LabsFlag } from '../../../enums/labsFlag'
import { Scope } from '../../../enums/scope'
import { useLabsMenuFlags } from '../../../hooks/useLabsMenuFlags'
import { isAuthorized } from '../../../utils/isAuthorized'
import { LEGACY_RECONCILIATION_VIEW_COUNTRY_ID } from '../constants/legacyReconciliationViewCountryId'
import { ReconciliationViewBannerPage } from '../enums/reconciliationViewBannerPage'
import { useBankTransactionsAccess } from './useBankTransactionsAccess'

export const useShouldShowReconciliationViewBanner = (page: ReconciliationViewBannerPage) => {
  const { organization } = useUserOrganization()
  const { organizationSettings, isLoading } = useUserOrganizationSettings()
  const { isReconciliationViewVisible, isTransactionsViewVisible } = useBankTransactionsAccess()
  const labsFlags = useLabsMenuFlags()

  const isDismissed = organizationSettings?.isReconciliationViewBannerDismissed === '1'
  // Only users who see a single view can switch; accountants see both views and get no banner
  const isCurrentViewOnly =
    page === ReconciliationViewBannerPage.Reconciliation
      ? isReconciliationViewVisible && !isTransactionsViewVisible
      : isTransactionsViewVisible && !isReconciliationViewVisible

  const shouldShowBanner =
    !isLoading &&
    !!organizationSettings &&
    organization?.countryId === LEGACY_RECONCILIATION_VIEW_COUNTRY_ID &&
    !labsFlags[LabsFlag.ReconciliationViewAsDefault] &&
    // The banner writes organization settings, so it follows the same scope as the settings page
    isAuthorized(Scope.BankReconciliationWrite) &&
    !isDismissed &&
    isCurrentViewOnly

  return { shouldShowBanner }
}
